import React, { Fragment, useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import classnames from 'classnames';

import useKeyboardEvent from '../../hooks/useKeyboardEvent';
import SendUserGiftsModal from 'components/modals/SendUserGiftsModal/SendUserGiftsModal';
import UserSearchModal from 'components/modals/UserSearchModal/UserSearchModal';
import CountrySelectorModal from 'components/modals/CountrySelectorModal/CountrySelectorModal';
import VerifyAchModal from 'components/modals/VerifyAchModal/VerifyAchModal.js';

import FundGroupModal from 'components/modals/FundGroupModal/FundGroupModal.js';
import ConfirmModal from 'components/modals/ConfirmModal/ConfirmModal.js';
import ContextSelectorModal from 'components/modals/ContextSelectorModal/ContextSelectorModal';
import EntityListModal from 'components/modals/EntityListModal/EntityListModal';
import FollowFollowingModal from 'components/modals/FollowFollowingModal/FollowFollowingModal';
import TermsModal from 'components/modals/TermsModal/TermsModal';
import FavoriteNonprofitModal from 'components/modals/FavoriteNonprofitModal/FavoriteNonprofitModal';
import TermsOfUseModal from 'components/modals/TermsOfUseModal/TermsOfUseModal';
import PrivacyPolicyModal from 'components/modals/PrivacyPolicyModal/PrivacyPolicyModal';
import ShareModal from 'components/modals/ShareModal/ShareModal';
import CommentModal from 'components/modals/CommentModal/CommentModal';
import ReportModal from 'components/modals/ReportModal/ReportModal';
import CauzeUpdateModal from 'components/modals/CauzeUpdateModal/CauzeUpdateModal';
import CheckoutModal from 'components/modals/CheckoutModal/CheckoutModal';
import VideoModal from 'components/modals/VideoModal/VideoModal';
import ProfileModal from 'components/modals/ProfileModal/ProfileModal';
import RedeemGiftModal from 'components/modals/RedeemGiftModal/RedeemGiftModal';
import GiftDetailModal from 'components/modals/GiftDetailModal/GiftDetailModal';

const ModalNotificationProvider = ({
  uiStore,
  eventStore,
  children,
  userReportsStore,
  cauzePurchaseStore,
  profileStore,
  donationLandingStore,
}) => {
  useKeyboardEvent('Escape', () => {
    uiStore.closeModal();
    uiStore.closeNotification();
  });

  const modalProps = toJS(uiStore.modalProps);

  useEffect(() => {
    if (uiStore.modal) {
      document.querySelector('html').style.overflowY = 'hidden';
    } else {
      document.querySelector('html').style.overflowY = 'scroll';
    }

    return () => {
      document.querySelector('html').style.overflowY = 'scroll';
    };
  }, [uiStore.modal]);

  return (
    <Fragment>
      {uiStore.notification && (
        <div
          className={classnames(
            'notification flex justify-center items-center app-notification !rounded-lg ',
            {
              'is-success': uiStore.notification.type === 'SUCCESS',
              'is-danger': uiStore.notification.type === 'ERROR',
            },
          )}
        >
          {uiStore.notification.body}
          <button
            onClick={() => uiStore.closeNotification()}
            className="delete "
          ></button>
        </div>
      )}
      {uiStore.modal === 'CONTEXT_SELECTOR' && (
        <ContextSelectorModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'CONFIRM' && (
        <ConfirmModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'SEND_GIFTS' && (
        <SendUserGiftsModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'FAVORITE_NONPROFITS' && (
        <FavoriteNonprofitModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'FUND_GROUP' && (
        <FundGroupModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'USER_SEARCH' && (
        <UserSearchModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'COUNTRY_SELECTOR' && (
        <CountrySelectorModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'CHECKOUT' && (
        <CheckoutModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'VERIFY_ACH' && (
        <VerifyAchModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'ENTITY_LIST' && (
        <EntityListModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'FOLLOW_FOLLOWING' && (
        <FollowFollowingModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'TERMS' && (
        <TermsModal {...modalProps} isOpen onToggleClose={uiStore.closeModal} />
      )}
      {uiStore.modal === 'TERMS_OF_USE' && (
        <TermsOfUseModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'PRIVACY_POLICY' && (
        <PrivacyPolicyModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'SHARE_MODAL' && (
        <ShareModal {...modalProps} isOpen onToggleClose={uiStore.closeModal} />
      )}
      {uiStore.modal === 'REDEEM_GIFT_MODAL' && (
        <RedeemGiftModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
          donationLandingStore={donationLandingStore}
        />
      )}
      {uiStore.modal === 'PROFILE_MODAL' && (
        <ProfileModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {uiStore.modal === 'REPORT' && (
        <ReportModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
          userReportsStore={userReportsStore}
          uiStore={uiStore}
        />
      )}
      {uiStore.modal === 'COMMENT' && (
        <CommentModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
          userReportsStore={userReportsStore}
          cauzePurchaseStore={cauzePurchaseStore}
          profileStore={profileStore}
          uiStore={uiStore}
        />
      )}
      {uiStore.modal === 'UPDATE_CAUZE_MODAL' && (
        <CauzeUpdateModal
          {...modalProps}
          isOpen
          eventStore={eventStore}
          onToggleClose={uiStore.closeModal}
          profileStore={profileStore}
          uiStore={uiStore}
        />
      )}
      {uiStore.modal === 'VIDEO_MODAL' && (
        <VideoModal {...modalProps} isOpen onToggleClose={uiStore.closeModal} />
      )}
      {uiStore.modal === 'GIFT_DETAIL_MODAL' && (
        <GiftDetailModal
          {...modalProps}
          isOpen
          onToggleClose={uiStore.closeModal}
        />
      )}
      {children}
    </Fragment>
  );
};

export default inject(
  'uiStore',
  'eventStore',
  'userReportsStore',
  'cauzePurchaseStore',
  'profileStore',
  'donationLandingStore',
)(observer(ModalNotificationProvider));
